// axios
import axiosLibrary from 'axios';

import { log } from '@goldblack/client-utils';
import { def } from '@goldblack/shared';
import { setApiImport, impo } from './api-import.js';

var axiosInstance = null;

// Multipart bodies can be tens of MB; log only the part names and file sizes, never the bytes.
function describeBody(data) {
    if (typeof FormData !== 'undefined' && data instanceof FormData) {
        return JSON.stringify(
            Array.from(data.entries()).map(([key, value]) => (value instanceof Blob ? `${key}: ${value.size}B` : key)),
        );
    }
    return JSON.stringify(data);
}

function request(req) {
    console.log(
        `%c${req.method?.toUpperCase()} %c-> ${req.url} %c${describeBody(req.data)}`,
        'font-weight: bold;',
        'font-weight: bold; color:blue',
        'background: #28282B; color: #FAE7B5; padding: 2px 4px; border-radius: 2px;',
    );
    return req;
}

function response(res) {
    console.log(
        `%c${res.config.method?.toUpperCase()} %c<- ${res.config.url} ${res.statusText} %c${JSON.stringify(res.data)}`,
        'font-weight: bold;',
        'font-weight: bold; color:blue',
        'background: #28282B; color: #FAE7B5; padding: 2px 4px; border-radius: 2px;',
    );
    return res;
}

function error(err) {
    if (!err.response) return Promise.reject(err);
    const { code, data } = err.response.data;
    const status = err.response.status;

    switch (status) {
        case def.StatusCodes.SERVICE_UNAVAILABLE:
            if (code === def.ErrorCode.AUTH_SERVER_MAINTENANCE) {
                impo.transience.setState('path.gateway', 'maintenance');
                return Promise.resolve();
            }
            break;
        case def.StatusCodes.FORBIDDEN:
            switch (code) {
                case def.ErrorCode.NOTICE:
                    impo.transience.concatState('main.notice', data);
                    break;
            }
            break;
    }
    return Promise.reject(err);
}

function load(imp) {
    // 이미 인스턴스가 있다면 다시 생성하지 않고 무시합니다.
    if (axiosInstance) {
        log.consoleLog('Axios instance already exists. Skipping load.');
        return;
    }

    setApiImport(imp);

    axiosInstance = axiosLibrary.create({
        baseURL: imp.baseURL || '',
        withCredentials: true, // 쿠키 공유 설정
        validateStatus: (status) => status === 304 || (status >= 200 && status < 300),
    });

    // interceptor
    axiosInstance.interceptors.request.use(request);
    axiosInstance.interceptors.response.use(response, error);
}

export { axiosInstance as axios, load };
